export const pmisColorsMixin = {
    computed: {
        computedDarkBackground() {
            return this.convertedName + "-dark-background";
        },
        computedBackground() {
            return this.convertedName  +"-background";
        },
        computedBackgroundBorder() {
            return this.computedBackground + " " + this.convertedName + "-dark-border";
        },
        computedDarkTextColor() {
            return this.convertedName + "-dark-text";
        },
        convertedName() {
            return this.name.split(/(?=[A-Z])/).join('-').toLowerCase();
        }
    }
};
